import { useState } from "react";
import { kampanyalar } from "@/mocks/dashboard";

const CARD_BG = "#141720";
const BORDER = "#1e2130";
const TEXT_PRIMARY = "#e8eaf0";
const TEXT_SECONDARY = "#5a5f7a";

export default function KampanyaAnalizi() {
  const [siralama, setSiralama] = useState("goruntulenme");
  const [filtre, setFiltre] = useState("Tümü");
  const [insightKapali, setInsightKapali] = useState(false);

  const filtrelenmis = kampanyalar
    .filter((k) => filtre === "Tümü" || k.durum === filtre)
    .sort((a, b) => {
      if (siralama === "goruntulenme") return b.goruntulenme - a.goruntulenme;
      if (siralama === "donusum") return b.donusum - a.donusum;
      if (siralama === "tiklama") return b.tiklama - a.tiklama;
      return 0;
    });

  const maxGoruntulenme = Math.max(...kampanyalar.map((k) => k.goruntulenme));
  const ACCENT_COLORS = ["#7c3aed", "#10b981", "#ec4899", "#f59e0b", "#8b5cf6", "#06b6d4"];

  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between flex-wrap gap-4">
        <div>
          <h2 className="text-lg font-bold" style={{ color: TEXT_PRIMARY }}>Kampanya Analizi</h2>
          <p className="text-sm mt-1" style={{ color: TEXT_SECONDARY }}>Tüm kampanyaların performans karşılaştırması</p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <div className="flex items-center gap-1 rounded-lg p-1" style={{ backgroundColor: "#0d0f16" }}>
            {["Tümü", "Aktif", "Pasif"].map((f) => (
              <button
                key={f}
                onClick={() => setFiltre(f)}
                className="px-3 py-1.5 rounded-md text-xs font-medium transition-all cursor-pointer whitespace-nowrap"
                style={{
                  backgroundColor: filtre === f ? "#1e2130" : "transparent",
                  color: filtre === f ? "#a78bfa" : TEXT_SECONDARY,
                }}
              >
                {f}
              </button>
            ))}
          </div>
          <select
            value={siralama}
            onChange={(e) => setSiralama(e.target.value)}
            className="text-sm rounded-lg px-3 py-2 cursor-pointer outline-none"
            style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}`, color: "#8b8fa8" }}
          >
            <option value="goruntulenme">En Yüksek Görüntülenme</option>
            <option value="donusum">En Yüksek Dönüşüm</option>
            <option value="tiklama">En Yüksek Tıklama</option>
          </select>
        </div>
      </div>

      {/* Özet Kartlar */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {[
          { label: "Toplam Kampanya", deger: kampanyalar.length, ikon: "ri-megaphone-line", accent: "#7c3aed", bg: "rgba(124,58,237,0.15)" },
          { label: "Ortalama Görüntülenme", deger: Math.round(kampanyalar.reduce((s, k) => s + k.goruntulenme, 0) / kampanyalar.length).toLocaleString("tr-TR"), ikon: "ri-eye-line", accent: "#f59e0b", bg: "rgba(245,158,11,0.15)" },
          { label: "En İyi Dönüşüm", deger: `%${Math.max(...kampanyalar.map((k) => k.donusum))}`, ikon: "ri-trophy-line", accent: "#10b981", bg: "rgba(16,185,129,0.15)" },
        ].map((item, i) => (
          <div key={i} className="rounded-2xl p-4 flex items-center gap-4" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
            <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: item.bg }}>
              <i className={`${item.ikon} text-lg`} style={{ color: item.accent }}></i>
            </div>
            <div>
              <p className="text-xl font-bold" style={{ color: TEXT_PRIMARY }}>{item.deger}</p>
              <p className="text-xs" style={{ color: TEXT_SECONDARY }}>{item.label}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Insight */}
      {!insightKapali && (
        <div className="rounded-2xl p-4 flex items-start gap-3" style={{ backgroundColor: "rgba(245,158,11,0.08)", border: "1px solid rgba(245,158,11,0.2)" }}>
          <div className="w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0" style={{ backgroundColor: "rgba(245,158,11,0.15)" }}>
            <i className="ri-lightbulb-line text-sm" style={{ color: "#f59e0b" }}></i>
          </div>
          <div className="flex-1">
            <p className="text-sm font-bold" style={{ color: "#f59e0b" }}>Akıllı Öneri</p>
            <p className="text-sm mt-0.5" style={{ color: "#fbbf24" }}>
              "Yaz Tatili Paketi 2025" kampanyası yüksek ilgi görüyor ancak dönüşüm düşük. Form adımını sadeleştirmeyi ve WhatsApp yönlendirmesini öne çıkarmayı deneyin.
            </p>
          </div>
          <button onClick={() => setInsightKapali(true)} className="cursor-pointer flex-shrink-0" style={{ color: "#f59e0b" }}>
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>
      )}

      {/* Tablo */}
      <div className="rounded-2xl overflow-hidden" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr style={{ backgroundColor: "#0d0f16", borderBottom: `1px solid ${BORDER}` }}>
                {["Kampanya Adı", "Görüntülenme", "Ort. Süre", "Tıklama", "Dönüşüm", "Durum"].map((h) => (
                  <th key={h} className="text-left px-5 py-3.5 text-xs font-semibold uppercase tracking-wide" style={{ color: TEXT_SECONDARY }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtrelenmis.map((k, i) => (
                <tr
                  key={k.id}
                  className="transition-colors cursor-pointer"
                  style={{ borderBottom: `1px solid ${BORDER}` }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.03)")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                >
                  <td className="px-5 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-lg flex items-center justify-center text-white text-xs font-bold flex-shrink-0" style={{ backgroundColor: ACCENT_COLORS[i % ACCENT_COLORS.length] }}>
                        {k.ad.charAt(0)}
                      </div>
                      <div>
                        <p className="text-sm font-semibold" style={{ color: TEXT_PRIMARY }}>{k.ad}</p>
                        <p className="text-xs" style={{ color: TEXT_SECONDARY }}>{k.kategori}</p>
                      </div>
                    </div>
                  </td>
                  <td className="px-5 py-4">
                    <p className="text-sm font-semibold" style={{ color: TEXT_PRIMARY }}>{k.goruntulenme.toLocaleString("tr-TR")}</p>
                    <div className="mt-1 h-1 rounded-full w-24 overflow-hidden" style={{ backgroundColor: "#1e2130" }}>
                      <div className="h-full rounded-full" style={{ width: `${(k.goruntulenme / maxGoruntulenme) * 100}%`, backgroundColor: "#7c3aed" }}></div>
                    </div>
                  </td>
                  <td className="px-5 py-4"><span className="text-sm" style={{ color: "#8b8fa8" }}>{k.ortSure}</span></td>
                  <td className="px-5 py-4">
                    <p className="text-sm font-semibold" style={{ color: TEXT_PRIMARY }}>{k.tiklama.toLocaleString("tr-TR")}</p>
                    <p className="text-xs" style={{ color: TEXT_SECONDARY }}>%{k.tiklamaOrani} oran</p>
                  </td>
                  <td className="px-5 py-4">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-bold" style={{ color: TEXT_PRIMARY }}>%{k.donusum}</span>
                      <span className="text-xs font-medium" style={{ color: k.donusumTrend > 0 ? "#10b981" : "#ef4444" }}>
                        {k.donusumTrend > 0 ? "↑" : "↓"} {Math.abs(k.donusumTrend)}%
                      </span>
                    </div>
                  </td>
                  <td className="px-5 py-4">
                    <span
                      className="text-xs font-semibold px-2.5 py-1 rounded-full"
                      style={{
                        backgroundColor: k.durum === "Aktif" ? "rgba(16,185,129,0.15)" : "rgba(90,95,122,0.2)",
                        color: k.durum === "Aktif" ? "#10b981" : "#5a5f7a",
                      }}
                    >
                      {k.durum}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
